export default () => {
  const isLocked = isServer() ? ref(false) : useScrollLock(document.body)

  const lock = () => isLocked.value = true
  const unlock = () => isLocked.value = false

  return {
    isLocked,
    lock,
    unlock
  }
}
